import React, {Component, ReactElement} from 'react'

import RoomToResidentRepo from './repository/NatRoomToResidentRepo'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {MESSAGE_TYPE} from '../../../CodeMaster'
import {Location} from 'react-router-dom'

interface Props {
    roomToResidentRepo: RoomToResidentRepo
    location: Location
}

interface State {
    exportButtonDisabledFlg: boolean
}

class NatAdminOutputAuthenticationKeyPage extends Component<Props & AdminPagePropsSet, State> {
    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.state = {
            exportButtonDisabledFlg: false,
        }
    }

    async componentDidMount(): Promise<void> {
        this.props.eventEmitter.clearHeadingAreaMessage()
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})

        if (initialMessage) {
            const activationMessage: HeadingAreaMessageParams = {
                title: null,
                messageLevel: MESSAGE_TYPE.INFORMATION,
                detail: initialMessage.detail,
            }
            this.props.eventEmitter.showHeadingAreaMessage(activationMessage)
        }
    }

    // 一括出力ボタン押下時
    async registerAdminUserPasswordButton(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        // 2重送信対応のため、一括出力ボタンを非表示にする
        this.setState({exportButtonDisabledFlg: true})

        try {
            const tempLink: HTMLAnchorElement = document.createElement('a')
            tempLink.href = '/api/admin/roomToResident/export'
            document.body.appendChild(tempLink)
            tempLink.click()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({exportButtonDisabledFlg: false})
        }
    };

    render(): ReactElement {
        return (
            <>
                <PageMainArea/>
                <PageFooterArea>
                    <PageFotterAreaRight/>
                    <PageFotterAreaLeft>
                        <AdminDefaultMediumButton
                            onClick={this.registerAdminUserPasswordButton.bind(this)}
                            disabled={this.state.exportButtonDisabledFlg}>
                            一括出力
                        </AdminDefaultMediumButton>
                    </PageFotterAreaLeft>
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminOutputAuthenticationKeyPage)
